import NoResult from "./components/NoResult";
import SurveyAppView from "./containers/SurveyAppView";
import { HashRouter, Route, Routes, useParams } from "react-router-dom";

function SurveyApp() {
  document.title = "Survey";

  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/survey/:id" element={<SurveyRoute />} />
          <Route path="*" element={<NoResult title="Page Not Found" />} />
        </Routes>
      </HashRouter>
    </>
  );
}

function SurveyRoute() {
  const { id } = useParams();
  return <SurveyAppView surveyEventId={id} />;
}

export default SurveyApp;
